import React from 'react';
import { Link } from 'react-router-dom';

// Use the same images that appear in BlogPost1, BlogPost2, BlogPost3
import blogImage1 from '../assets/blog-feature1.jpg';
import blogImage2 from '../assets/blog-feature2.jpg';
import blogImage3 from '../assets/blog-feature3.jpg';

const blogPosts = [
  {
    title: '10 Creative Challenges to Spark Friendly Rivalry',
    excerpt: 'Fun, innovative ways to kick-start lively showdowns and forge unforgettable memories.',
    image: blogImage1,
    link: '/blog/creative-challenges',
  },
  {
    title: 'Compete Smarter, Not Harder: Building a Culture of Responsible Bantr',
    excerpt: 'Elevate your friendly competitions with positivity, fairness, and camaraderie.',
    image: blogImage2,
    link: '/blog/responsible-bantr',
  },
  {
    title: 'Supercharge Your Rivalries: How to Keep Friendly Competition Fun',
    excerpt: 'Transform everyday tasks into epic rivalries without ever losing that playful spark.',
    image: blogImage3,
    link: '/blog/supercharge-rivalries',
  },
];

const BlogSection = () => {
  return (
    <section className="py-20 bg-[#FFFFFF]">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-[#333333] text-center mb-10">
          Blog &amp; Resources
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {blogPosts.map((post, index) => (
            <Link
              to={post.link}
              key={index}
              className="bg-[#F5F5F5] rounded-lg overflow-hidden shadow transform hover:scale-105 transition-transform"
            >
              <img
                src={post.image}
                alt={post.title}
                className="w-full h-auto"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-[#333333] mb-2">
                  {post.title}
                </h3>
                <p className="text-[#666666] mb-4">{post.excerpt}</p>
                {/* Entire card is clickable; removed the "Read More" link */}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
